import React, { Component } from 'react';
import { StyleSheet, View, Platform } from 'react-native';

import OPComponent from './op_component';
import DatePicker from './date_picker';
import NavBar from '../../navbar';
import Navigation from '../../navigation';
import { __WEB__, THEME } from '../../constants/styles';
import CTAButton from './cta_button';

const stripTime = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

export default class GenericDateTimeModal extends OPComponent {
  static options(passProps) {
    return {
      topBar: {
        leftButtons: [NavBar.buttons.cancel],
        rightButtons: [NavBar.buttons.save],
      },
    };
  }

  constructor(props) {
    super(props);
    let defaultDate = stripTime(props.selectedDate || new Date());

    if (props.minDate && defaultDate < stripTime(props.minDate)) {
      defaultDate = stripTime(props.minDate);
    } else if (props.maxDate && defaultDate > stripTime(props.maxDate)) {
      defaultDate = stripTime(props.maxDate);
    }
    this.state = {
      selectedDate: defaultDate,
      pickerOpen: !__WEB__,
    };
    this._ref = React.createRef();
  }

  navigationButtonPressed = ({ buttonId }) => {
    const { componentId } = this.props;

    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    Navigation.registerForButtonEvents(this);
    // wait for the modal to open before showing the picker to prevent focus issues during animation
    if (__WEB__) {
      setTimeout(() => {
        this.setState({
          pickerOpen: true,
        });
      }, 350);
    }
  }
  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
  }

  onSave = () => {
    if (this._ref.current?.validate && !this._ref.current?.validate()) return;
    this.props.onDate?.(this.state.selectedDate);
    Navigation.close(this.props);
  };
  onDate = (date) => {
    // In Android onDate fires when OK button on date picker is pressed
    if (Platform.OS === 'android') {
      this.setState({ pickerOpen: false });
    }

    this.setState({ selectedDate: date });
  };

  clear = () => {
    this.props.onDate?.(null);
    Navigation.close(this.props);
  };
  render() {
    if (!!__WEB__ && !this.state.pickerOpen) return null;
    return (
      <View style={styles.container}>
        <View style={styles.pickerContainer}>
          <DatePicker
            ref={this._ref}
            {...this.props}
            minimumDate={this.props.minDate}
            maximumDate={this.props.maxDate}
            selectedDate={this.state.selectedDate}
            onDate={this.onDate}
            mode={this.props.mode}
            pickerOpen={this.state.pickerOpen}
            label={null}
          />
        </View>
        {!!this.props.clearable && (
          <View style={{ alignItems: 'center', marginTop: 10 }}>
            <CTAButton
              style={{ paddingHorizontal: 25 }}
              onPress={this.clear}
              label={`Remove ${this.props.label}`}
            />
          </View>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: __WEB__
    ? {
        flex: 1,
        paddingTop: 50,
        backgroundColor: 'white',
        alignItems: 'center',
      }
    : {
        ...THEME.containerAlt,
      },
  pickerContainer: __WEB__
    ? {
        width: 351,
        height: 370,
      }
    : null,
});
